import { Component, OnInit,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AdminsService } from 'src/app/_services/admins/admins.service';
import { UploadFileService } from 'src/app/_services/UploadFile/upload-file.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-checkout-inqq',
  templateUrl: './checkout-inqq.component.html',
  styleUrls: ['./checkout-inqq.component.css'],
})
export class CheckoutInqqComponent implements OnInit {
  checkOut: any = [];
  headerData: Array<any> = [];
  showEdit: Array<boolean> = [];
  subscriptions: Subscription[] = [];

  numbercheckOut = 0;
  afterUploadImage: string;
  selectedContractImg: any;
  display22: string;
  imageSize: any;
  display33: string;
  constructor(
    private _checkOutService: AdminsService,
    private messageService: MessageService,
    private uploadService: UploadFileService,
    public router: Router
  ) {}

  globalFilter: string = '';

  currentPage: number = 0;
 @ViewChild('dt2', { static: false }) dt2?: any;
  tableReady = false;

  onPageChange(event: any) {
    this.currentPage = event.first;
    console.log(this.currentPage)
    localStorage.setItem('checkPage', this.currentPage.toString());
  }


  ngOnInit() {
    const savedPage = localStorage.getItem('checkPage');
    this.currentPage = savedPage ? +savedPage : 0;
    console.log(this.currentPage)
    this.initFakeData();
    // this.getAllcheckOut(this.statusinquire);
      //////////////////////////////////////////////////
      if(localStorage.getItem('pageNoCheck')){
    
        let numberF=Number(localStorage.getItem('firstCheck'))
  
        let numberR=Number(localStorage.getItem('rowsCheck'))
        let number=Number(localStorage.getItem('pageNoCheck'))
  
       
        this.first=numberF
        this.rows=numberR
        this.pageNumber=number
  
        this.getAllcheckOut(this.statusinquire);

  
  
        
      }else{
        this.getAllcheckOut(this.statusinquire);

  
  
      }
      //////////////////////////////////////////////////
    const connection = new signalR.HubConnectionBuilder()

      .withUrl(environment.apiUrl + '/notify', { withCredentials: false })
      .build();

    connection
      .start()
      .then(function () {})
      .catch(function (err) {
        return console.error(err.toString());
      });

    connection.on('NewInquiry', (result: any) => {
      this.getAllcheckOut(this.statusinquire);
      //this.messageService.add({ severity: 'info', summary: 'New Booking Request', detail: result.noti_Name });
    });
  }
  checkOutRole: any;
  is_Super: any;

  gotopage() {
    let url: string = 'unlegal';
    this.router.navigateByUrl(url);
  }
  statusinquire: any = '';
  pageNumber = 1;
  pagesize = 10;
  totalofPages = 0;
  disablenext = false;
  disableperv = false;
  first: number = 1;
  rows: number = 10;

  date = 'All';
  totalRecords = 0;
  checKoutInstead:any[]=[
    {
      "req_ID": "4cee7c0b-893d-4b76-afe1-d11d71a37137",
      "userID":"74446a17-9e10-42fe-bd5c-191fa9d106e6",
      "req_Code": "REQ001",
      "user_Photo": "https://via.placeholder.com/150",
      "user_Name": "John Doe",
      "rented_Apt": "Apartment 101",
      "rent_Deposit": 500,
      "start_Date": "2025-01-01",
      "end_Date": "2025-01-10",
      "status": "Pending",
      "checkOut_Date": "2025-01-13T13:35:54.974Z"
    },
    {
      "req_ID": "f1e2d3c4-b5a6-0987-cdef-543210987654",
      "userID":"74446a17-9e10-42fe-bd5c-191fa9d106e6",

      "req_Code": "REQ002",
      "user_Photo": "https://via.placeholder.com/150",
      "user_Name": "Jane Smith",
      "rented_Apt": "Apartment 202",
      "rent_Deposit": 600,
      "start_Date": "2025-01-05",
      "end_Date": "2025-01-12",
      "status": "Approved",
      "checkOut_Date": "2025-01-15T14:00:00.000Z"
    },
    {
      "req_ID": "abcd1234-5678-ef90-ab12-34567890cdef",
      "userID":"74446a17-9e10-42fe-bd5c-191fa9d106e6",

      "req_Code": "REQ003",
      "user_Photo": "https://via.placeholder.com/150",
      "user_Name": "Michael Johnson",
      "rented_Apt": "Apartment 303",
      "rent_Deposit": 450,
      "start_Date": "2025-01-10",
      "end_Date": "2025-01-17",
      "status": "Rejected",
      "checkOut_Date": "2025-01-20T10:00:00.000Z"
    },
    {
      "req_ID": "1234abcd-5678-ef90-3456-7890cdefabcd",
      "userID":"74446a17-9e10-42fe-bd5c-191fa9d106e6",

      "req_Code": "REQ004",
      "user_Photo": "https://via.placeholder.com/150",
      "user_Name": "Alice Brown",
      "rented_Apt": "Apartment 404",
      "rent_Deposit": 700,
      "start_Date": "2025-01-15",
      "end_Date": "2025-01-22",
      "status": "Pending",
      "checkOut_Date": "2025-01-25T16:00:00.000Z"
    }
  ]

  goBookingDetails(req_ID:string ,userID:string){
    this.router.navigate(['checkout-inquire/booking-details',req_ID,userID]);
  }

  getAllcheckOut(statuscheckOut: any) {
    //this.pagesize,
    this.checkOut = [];
    this.numbercheckOut = 0;
    this.subscriptions.push(
      this._checkOutService
        .GetCheckoutList(
          this.pageNumber,
          20000,
          this.searchText,
          statuscheckOut,
          this.date
        )
        .subscribe(
          (res: any) => {
            this.checkOut = res['data'];
            this.numbercheckOut = this.checkOut.length;
            this.totalofPages = res['totalPages'];
            this.totalRecords = res['totalRecords'];

            if (this.totalofPages == this.pageNumber) {
              this.disablenext = true;
            } else {
              this.disablenext = false;
            }
            if (this.pageNumber == 1) {
              this.disableperv = true;
            } else {
              this.disableperv = false;
            }

            const savedPage = localStorage.getItem('checkPage');
            this.currentPage = savedPage ? +savedPage : 0;
            console.log(this.currentPage) 
            this.tableReady = true;
          },
          (error) => {
            console.error('Error fetching owners:', error);
          }
        )
    );
  }
  tiggerPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    let calcPageNumber = Math.floor(this.first / this.rows) + 1;
    this.pageNumber = calcPageNumber;
    this.getAllcheckOut(this.statusinquire);

    /////////////
    localStorage.setItem('firstCheck',this.first.toString())
    localStorage.setItem('pageNoCheck',this.pageNumber.toString())


    localStorage.setItem('rowsCheck',this.rows.toString())
    /////////////
  }
  ids: any = [];
  detailperson(event: any, id: any) {
    this.showEdit = [];
    event.stopPropagation();

    this.showEdit[id] == true
      ? (this.showEdit[id] = false)
      : (this.showEdit[id] = true);
  }
  showSide: string = '';

  addItem(value: string): void {
    this.showSide = value;
  }
  dropdownOption: Array<any> = [];
  listDropDown: Array<object> = [
    { name: 'All' },
    { name: 'Today' },
    { name: 'Last week' },
    { name: 'This month' },
    { name: 'This year' },
  ];
  Inquiries = [];
  InquireFillterLists: Array<any> = [];
  InquireFillterSelected: Array<any> = [];
  initFakeData(): void {
    this.InquireFillterLists = [
      {
        id: 0,
        name: 'All',
      },
      {
        id: 1,
        name: 'completed',
      },
      {
        id: 2,
        name: 'Ready Checkout',
      },
      {
        id: 3,
        name: 'end soon',
      },
    ];
    this.InquireFillterSelected = [true];
  }
  selectedfromDropDown(value: any) {
    this.date = value.name;
    this.getAllcheckOut(this.statusinquire);
  }
  checkindex = 0;
  clickIquires(index: any) {
    this.checkindex = index.target.value;
    this.InquireFillterSelected = this.InquireFillterSelected.map((data) =>
      data == true ? false : false
    );

    this.InquireFillterSelected[index.target.value] = true;
    if (index.target.value == 0) {
      this.statusinquire = 'All';
      this.getAllcheckOut(this.statusinquire);
    }
    if (index.target.value == 1) {
      this.statusinquire = 'completed';

      this.getAllcheckOut(this.statusinquire);
    }
    if (index.target.value == 2) {
      this.statusinquire = 'Ready Checkout';

      this.getAllcheckOut(this.statusinquire);
    }
    if (index.target.value == 3) {
      this.statusinquire = 'end soon';

      this.getAllcheckOut(this.statusinquire);
    }
  }
  onCloseModal1() {
    this.display1 = 'none';
  }
  display1: any = 'none';
  InsertCheckOut(REQ_ID: any,userid:any) {
    this.subscriptions.push(
      this._checkOutService.InsertCheckOut(REQ_ID,userid).subscribe(
        (res) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `${res.message}`,
          });
          this.display1 = 'block';
          this.getAllcheckOut(this.statusinquire);
        },
        (error) => {
          this.display1 = 'none';

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${error.error.message[0]}`,
          });
        }
      )
    );
  }

  hidecard() {
    this.showEdit = [];
  }
  searchText: any = '';
  search: boolean = false;

  searchKey(data: string) {
    debugger;
    this.searchText = data;
    this.getAllcheckOut(this.statusinquire);
  }
  searchTextChange: any;
  searchAction(event: KeyboardEvent) {
    if (this.searchText.trim() === '' && (event.key === 'Backspace' || event.key === ' ')) {
      event.preventDefault();
      return;
  }
    this.getAllcheckOut(this.statusinquire);
  }
  display3: any;
  BankDetails: any;
  GetBankDetails(Req_ID: any) {
    this._checkOutService.GetBankDetails(Req_ID).subscribe(
      (res: any) => {
        this.BankDetails = res;
      },
      (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${err.error.message[0]}`,
        });
      }
    );

    this.display2 = 'block';
  }
  display2: any;
  Is_PDF: any;
  onCloseModal2() {
    this.display2 = 'none';
  }
  RefundDetails: any;
  GetRefundDetails(Req_ID: any) {
    this.subscriptions.push(
      this._checkOutService.GetRefundDetails(Req_ID).subscribe(
        (res) => {
          this.RefundDetails = res;
          this.Is_PDF = res.refund_Attachment.includes('.pdf') ? true : false;
        },
        (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${err.error.message[0]}`,
          });
        }
      )
    );
    this.display3 = 'block';
  }

  onCloseModal3() {
    this.display3 = 'none';
  }
  Refund_Transaction_ID: any;
  Refund_Attachment: any;
  ChangeRefund_ID(event: Event) {
    this.Refund_Transaction_ID = (event.target as HTMLInputElement).value;
  }

  onUploadContract(event: any, fieldName: string): void {
    // get the file
    const file = event.target.files[0];
    // convert the file to formdata
    const formData = new FormData();
    formData.append('fileData', file, file.name);
    // check if the file has been uploaded
    if (file) {
      // call the onUpload function to get the link to the file
      this.subscriptions.push(
        this.uploadService.uploadSingleFile(formData).subscribe(
          (img: any) => {
            // create url to preview file
            file.url = URL.createObjectURL(file);
            // check wich file uploaded
            fieldName == 'contract_Path'
              ? (this.selectedContractImg = file)
              : null;

            this.Refund_Attachment = img[0].file_Path;
            // patch the fieldName in Form

            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: `Attachments has uploaded Successfuly`,
            });

            this.afterUploadImage = 'true';
          },
          (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `Please try again`,
            });
          }
        )
      );
    }
  }
  opencloseModal(photo: any) {
    this.display22 = 'block';
    this.imageSize = photo;
  }

  PostRefunding() {
    this.subscriptions.push(
      this._checkOutService
        .PostRefunding(
          this.RefundDetails.req_ID,
          this.RefundDetails.inv_ID,
          this.Refund_Transaction_ID,
          this.Refund_Attachment
        )
        .subscribe(
          (ress) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Refunding Process has done',
            });
            this.getAllcheckOut(this.statusinquire);
            this.onCloseModal3();
          },
          (err: any) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${err.error.message[0]}`,
            });
          }
        )
    );
  }
  openmodel(image: any) {
    this.imageSize = image;
    this.display33 = 'block';
  }
  oncloseModal() {
    this.display33 = 'none';
  }
  ngOnDestroy() {
    for (let i = 0; i < this.subscriptions.length; i++)
      this.subscriptions[i].unsubscribe();
  }


  customSort(event: { data: any[], field: string, order: number }) {
    event.data.sort((a, b) => {
      let valueA = a[event.field];
      let valueB = b[event.field];
  
      console.log("Before Sorting:", valueA, valueB); // Debugging output
  
      // ✅ Handle null values properly
      if (valueA == null && valueB == null) return 0;
      if (valueA == null) return event.order;  // Null values should appear last in ascending order
      if (valueB == null) return -event.order; // Null values should appear first in descending order
  
      // ✅ Convert string dates (like "Mar 5, 2025") into Date objects for sorting
      if (this.isValidDate(valueA) && this.isValidDate(valueB)) {
        let dateA = new Date(valueA);
        let dateB = new Date(valueB);
        let result = (dateA.getTime() - dateB.getTime()) * event.order;
  
        console.log("Sorted Dates:", dateA, dateB, "Result:", result); // Debugging output
  
        return result;
      }
  
  
        // ✅ التحقق مما إذا كانت القيم تواريخ
        if (this.isDate(valueA) && this.isDate(valueB)) {
          return (new Date(valueA).getTime() - new Date(valueB).getTime()) * event.order;
        }
  
  
      // ✅ Handle numeric sorting
      if (!isNaN(valueA) && !isNaN(valueB)) {
        return (parseFloat(valueA) - parseFloat(valueB)) * event.order;
      }
  
      // ✅ Handle text sorting (case insensitive)
      return valueA.toString().localeCompare(valueB.toString(), undefined, { numeric: true }) * event.order;
    });
  
    console.log("After Sorting:", event.data.map(item => item[event.field])); // Debugging output after sorting
  }
  
  
  
  
  // ✅ دالة تتحقق مما إذا كانت القيمة تاريخًا
  isDate(value: any): boolean {
    return !isNaN(Date.parse(value));
  }
   
  
  isValidDate(dateString: string): boolean {
    return dateString != null && !isNaN(Date.parse(dateString));
  }


  ////////////////////////
  statuses = [
    { label: 'Completed', value: 'Completed' },
    { label: 'Ready Checkout', value: 'Ready Checkout' },
    { label: 'End in', value: 'End in' },
    { label: 'Waiting', value: 'Waiting' },
    { label: 'End Soon', value: 'End Soon' }



  ];
  
  getSeverity(status: string): string {
    if (!status) return '';
  
    if (status.includes('Ready Checkout')) return 'rounded-5 px-3 badge Current';
    if (status.includes('End in')) return 'rounded-5 px-3 badge Upcoming';
    if (status.includes('Completed')) return 'rounded-5 px-3 badge Approved';
    if (status.includes('Cancelled')) return 'rounded-5 px-3 badge Cancelled';
    if (status.includes('Waiting')) return 'rounded-5 px-3 badge Pending';
    if (status.includes('End Soon')) return 'rounded-5 px-3 badge Pending';
    if (status.includes('Rejected')) return 'rounded-5 px-3 badge Rejected';
    if (status.includes('CheckedOut')) return 'rounded-5 px-3 badge Waiting';
  
    return '';
  }
  

  ///////////////////////
}
